import CommentsEffect from "./../effects/commentsEffect";

export const sendComments = async (data) => {
  const resp = await CommentsEffect.sendComments(data);
  return resp;
};
